import { render, staticRenderFns } from "./sage.vue?vue&type=template&id=dff3aece&scoped=true"
import script from "./sage.vue?vue&type=script&lang=js"
export * from "./sage.vue?vue&type=script&lang=js"
import style0 from "./sage.vue?vue&type=style&index=0&id=dff3aece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff3aece",
  null
  
)

export default component.exports